import { EventsRecords, StepEvent } from '@samelogic/steps';

export function mergeStepEventIntoEventRecords(events: EventsRecords, stepEvent: StepEvent): EventsRecords {
  return {
    ...events,
    [stepEvent.stepName]: {
      [stepEvent.event]: { data: stepEvent.data }
    }
  };
}
0;
